import React, { Component }         from "react";
import { FontAwesomeIcon }          from '@fortawesome/react-fontawesome'
import { Button, Modal }            from "react-bootstrap";
import LoaderButton                 from "../../components/LoaderButton";
import { getUserProfileValidation } from "../../utils/AwsInvoke";
import { WhiteLabel }               from "../../utils/WhiteLabelProps";
import "../../css/modal/ModalProgramSummary.css";

var white_label = WhiteLabel();
const MainColor = white_label.company_primary_btn_color;
const CloseBtnColor = white_label.company_close_btn_color;

export default class ModalProgramSummary extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            showModalSimple: false,
            subscribeBtn: "Subscribe",
            submitBtnDisabled: false
        };
    }

    createMarkup(text) { return {__html: text}; };

    handleSubmit = async event => {
            this.setState({
                isLoading: true
            })
            var mktplc_id  = this.props.marketplaceId;
            var program_id = this.props.programId;

            this.props.handleSubscribeToMktplcProgram(program_id, mktplc_id);
      }

    static getDerivedStateFromProps(props, state) {
       if (props.programSubscribed !== state.programSubscribed) {
           // Close modal
           if(props.programSubscribed) props.onHide();
       }

       return null;
    }

    render() {

        return (
            <Modal
                show={this.props.show}
                onHide={this.props.onHide}
                style={{position:"absolute", top:50, height: "100%"}}
              >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title" className="marketplaceModalTitle">
                        Program Summary
                            { /*}<FontAwesomeIcon icon="sticky-note" />*/ }
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <span>
                      <img src={this.props.programImage} className="marketplaceModalProgramImageLarge"/>
                  </span>
                  <span className="marketplaceModalProgramTitle">
                      <b>{ this.props.programTitle }</b>
                  </span>
                  <div className="marketplaceModalProgramSummary">

                      <div>Time: <b>{this.props.programTotalTime}</b></div>
                      <div>Location: <b>{this.props.programLocation}</b></div>
                      <div>Length: <b>{(this.props.programDaysPerWeek == 0 ? "1 - 7" : this.props.programDaysPerWeek)} days per week</b></div>

                      <span style    = {{float:"right", position: "relative", left: -6, top:-87}}>
                      <LoaderButton
                          bsSize   = "large"
                          height   = "38px"
                          width    = "140px"
                          fontSize = "17px"
                          type     = "submit"
                          disabled = {this.state.submitBtnDisabled}
                          btncolor = { MainColor }
                          isLoading= {this.state.isLoading}
                          text     = { this.state.subscribeBtn }
                          onClick     = {this.handleSubmit}
                          loadingText ="Subscribing"
                        />
                      </span>
                      <br/>
                      <b>{ this.props.programSummary }</b>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                    <span style    = {{position: "relative", left: -10, top:0}}>
                      <LoaderButton
                          bsSize   = "large"
                          height   = "38px"
                          width    = "100px"
                          fontSize = "17px"
                          type     = "submit"
                          btncolor = { CloseBtnColor }
                          text     = "Close"
                          onClick     = {this.props.onHide}
                          loadingText = "Closing …"
                        />
                   </span>
                </Modal.Footer>
              </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/modal/ModalProgramSummary.js